<template>
  <div id="body">
    <div id="container">
      <img id="logo" class="fl" src="../assets/live/logo.png">
      <div id="type" class="fl">直播</div>
      <div class="cl"/>
      <h2>清创空间 x 春雪会计</h2>
      <h1>清创大讲堂 第39期</h1>
      <h4 v-if="!isLive || (isLive && !isSmallScreen)">疫情专题公益直播：<br>2020企业汇算清缴优惠事项解读<br>2019年度个人所得税综合所得汇算清缴</h4>
      <h3>主讲老师&nbsp;&nbsp;<span style="color:#efab60">春雪金牌讲师 王晓春</span><br>专注财务二十年</h3>
      <h3 style="white-space:nowrap;">直播时间&nbsp;&nbsp;<span style="color:#11c677">2020年4月24日 14:00-15:30</span></h3>
      <dl id="course">
        <dt>课程内容</dt>
        <dd>1.&nbsp;&nbsp;小型微利企业普惠性税收减免政策</dd>
        <dd>2.&nbsp;&nbsp;固定资产加速折旧优惠政策</dd>
        <dd>3.&nbsp;&nbsp;扶贫捐赠支出税前扣除政策</dd>
        <dd>4.&nbsp;&nbsp;税收优惠相关项目明细表的填报要点和实务</dd>
        <dd>5.&nbsp;&nbsp;2019年度个人所得税综合所得汇算清缴及实际操作建议</dd>
      </dl>
      <!-- 未开播显示的图片 START -->
      <div v-if="!isLive" id="zzz-container">
        <img id="zzz" src="../assets/live/zzz.png">
        <div>
          直播前15分钟，可进入直播间
        </div>
      </div>
      <!-- 未开播显示的图片 END -->

      <!-- 已开播显示的二维码 START -->
      <div v-else id="code-container">
        <img id="code" src="../assets/live/code.png">
        <div>
          长按二维码进入直播间
        </div>
      </div>
      <!-- 已开播显示的二维码 END -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLive: true, // 直播是否已开始（包括预热阶段）
      timer: null,
      pause: false,
      counter: 0,
      vHeight: null,
      ratio: 53.142857, // 视口高度与字号的系数
      isSmallScreen: false, // 是否是小屏机
      maxHeight: 600 // 小屏机极限高度
    }
  },
  mounted() {
    this.start()
    this.vHeight = this.determineScreenHeight()
    if (this.vHeight < this.maxHeight) {
      this.isSmallScreen = true
    }

    const rem = this.vHeight / this.ratio // 全局字号

    /* #body 开始 */
    /* 改此注释内的值会影响到 'container的高度' 开始 */
    const sharp_body_padding_top = 2 * rem + 'px' // #body 的 padding_top
    const sharp_body_padding_bottom = 2 * rem + 'px' // #body 的 padding_bottom
    /* 改此注释内的值会影响到 'container的高度' 结束 */
    const sharp_body_padding_left_and_right = 1.5 * rem + 'px' // #body 的 左右 padding
    const sharp_body_style = document.getElementById('body').style

    sharp_body_style.fontSize = rem + 'px'
    sharp_body_style.paddingTop = sharp_body_padding_top
    sharp_body_style.paddingBottom = sharp_body_padding_bottom
    sharp_body_style.paddingLeft = sharp_body_padding_left_and_right
    sharp_body_style.paddingRight = sharp_body_padding_left_and_right
    // sharp_body_style.height =
    //   (this.vHeight - sharp_body_padding_top - sharp_body_padding_bottom) + 'px'
    /* #body 结束 */

    /* h1 开始 */
    const h1_list = document.getElementsByTagName('h1')

    for (let i = 0; i < h1_list.length; i++) {
      h1_list[i].style.fontSize = 2.2 * rem + 'px'
      h1_list[i].style.marginBottom = 0.1 * rem + 'px'
    }
    /* h1 结束 */

    /* h2 开始 */
    const h2_list = document.getElementsByTagName('h2')

    for (let i = 0; i < h2_list.length; i++) {
      h2_list[i].style.fontSize = 1.2 * rem + 'px'
      h2_list[i].style.marginTop = 0.6 * rem + 'px'
    }
    /* h2 结束 */

    /* h3 开始 */
    const h3_list = document.getElementsByTagName('h3')

    for (let i = 0; i < h3_list.length; i++) {
      h3_list[i].style.fontSize = 1 * rem + 'px'
    }
    /* h3 结束 */

    /* h4 开始 */
    const h4_list = document.getElementsByTagName('h4')

    for (let i = 0; i < h4_list.length; i++) {
      h4_list[i].style.fontSize = 0.9 * rem + 'px'
    }
    /* h4 结束 */

    /* dt 开始 */
    const dt_list = document.getElementsByTagName('dt')

    for (let i = 0; i < dt_list.length; i++) {
      dt_list[i].style.marginBottom = 0.3 * rem + 'px'
    }
    /* dt 结束 */

    /* dd 开始 */
    const dd_list = document.getElementsByTagName('dd')

    for (let i = 0; i < dd_list.length; i++) {
      dd_list[i].style.textIndent = -1.3 * rem + 'px'
      dd_list[i].style.paddingLeft = 1.3 * rem + 'px'
    }
    /* dd 结束 */

    /* #container 开始 */
    const sharp_container_style = document.getElementById('container').style
    /* 改此注释内的值会影响到 'container的高度' 开始 */
    sharp_container_style.paddingTop = 2 * rem + 'px'
    sharp_container_style.paddingBottom = 2 * rem + 'px'
    /* 改此注释内的值会影响到 'container的高度' 结束 */
    sharp_container_style.paddingLeft = 2 * rem + 'px'
    sharp_container_style.paddingRight = 2 * rem + 'px'
    /* #container 结束 */

    /* #type 开始 */
    const sharp_type_style = document.getElementById('type').style
    sharp_type_style.marginTop = 0.4 * rem + 'px'
    sharp_type_style.marginLeft = 0.6 * rem + 'px'
    sharp_type_style.fontSize = 0.7 * rem + 'px'
    sharp_type_style.width = 3 * rem + 'px'
    /* #type 结束 */

    /* #logo 开始 */
    const sharp_logo_style = document.getElementById('logo').style
    sharp_logo_style.marginBottom = 1 * rem + 'px'
    /* #logo 结束 */

    if (this.isLive) {
      /* #code-container 开始 */
      const sharp_code_container_style = document.getElementById('code-container').style
      sharp_code_container_style.marginTop = 1 * rem + 'px'
      sharp_code_container_style.marginBottom = 1 * rem + 'px'
      /* #code-container 结束 */
    } else {
      /* #zzz-container 开始 */
      const sharp_zzz_container_style = document.getElementById('zzz-container').style
      if (this.isSmallScreen) {
        sharp_zzz_container_style.marginTop = 0.1 * rem + 'px'
      } else {
        sharp_zzz_container_style.marginTop = 2 * rem + 'px'
      }
      /* #zzz-container 结束 */

      /* #zzz 开始 */
      const sharp_zzz_style = document.getElementById('zzz').style
      if (this.isSmallScreen) {
        sharp_zzz_style.marginBottom = 0.2 * rem + 'px'
        sharp_zzz_style.width = 8 * rem + 'px'
      } else {
        sharp_zzz_style.marginBottom = 1 * rem + 'px'
        sharp_zzz_style.width = 9 * rem + 'px'
      }
      /* #zzz 结束 */
    }

    /* 设置 container的高度 开始 */
    document.getElementById('container').style.height = this.vHeight - 8 * rem + 'px'
  },
  beforeDestroy() {
    this.pause = true
    this.counter = 0
    clearInterval(this.timer)
    this.timer = null
  },
  methods: {
    determineScreenHeight() {
      const h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
      return h
    },
    start() {
      this.timer = setInterval(() => { // 创建页面刷新定时器
        if (!this.pause) {
          if (++this.counter === this.CONST.LIVE_RELOAD_INTERVAL) {
            window.location.reload()
            this.restart()
          }
        }
      }, 1000)
    },
    restart() {
      this.pause = false
      this.counter = 0
    }
  }
}
</script>

<style scoped>
  body, div, p, ul, li, dl, dt, dd {
    padding: 0;
    margin: 0;
    list-style: none;
  }
  #body {
    overflow: hidden;
    background-color: #eee;
  }
  h1 {
    white-space:nowrap;
    margin-top: -12px;
  }
  h2 {
    font-weight: normal;
  }
  h3 {
    font-weight: normal;
  }
  h4 {
    font-weight: normal;
  }
  #zzz-container {
    margin: 0 auto;
    text-align: center;
    color: #cfcfcf;
  }
  #container {
    background: #fff;
  }
  #type {
    padding: 3px;
    color: #fff;
    text-align: center;
    border-radius: 2px;
    background: #11c677;
  }
  dl {
    color: #888;
  }
  #logo {
    display: block;
    width: 30%;
  }
  #title {
    width: 100%;
  }
  #code-container {
    text-align: center;
    margin: 0 auto;
    width: 50%;
  }
  #code {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/live.vue